

export const signupConfirm = (model) => {
 return $.post('Account/SignUpComplete', model)
}



// WEBPACK FOOTER //
// ./src/pages/signupconfirm/signupconfirm.service.js